// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/nonstandard-landing-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/nonstandard-landing-technique/nonstandard-landing-technique.js';

mount([g0]);
